import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { SideNav } from './SideNav';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

const MainContent = styled.div`
  flex: 1;
  margin-left: ${props => props.$collapsed ? '70px' : '250px'};
  background-color: #f8f9fa;
  min-height: 100vh;
  transition: margin-left 0.3s ease;
`;

const ContentWrapper = styled.div`
  padding: 20px 24px;
`;

export function AdminLayout({ children }) {
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem('admin-token');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <LayoutContainer>
      <SideNav collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      <MainContent $collapsed={sidebarCollapsed}>
        <ContentWrapper>
          {children}
        </ContentWrapper>
      </MainContent>
    </LayoutContainer>
  );
} 